import React from 'react';
import { useSettings } from '../SettingsContext';

const RecoverySettings: React.FC<{ onSave: () => void }> = ({ onSave }) => {
  const { settings, updateSettings } = useSettings();
  const { recoveryConfig } = settings.checkoutConfig;

  const handleChange = (field: string, value: any) => {
    updateSettings({
      checkoutConfig: {
        ...settings.checkoutConfig,
        recoveryConfig: {
          ...recoveryConfig,
          [field]: value
        }
      }
    });
    onSave();
  };

  return (
    <div className="bg-white dark:bg-slate-800 rounded-[2.5rem] p-10 border border-slate-200 dark:border-slate-700 shadow-sm space-y-8">
      <h2 className="text-xl font-black text-slate-900 dark:text-white uppercase tracking-widest">Cart Recovery Configuration</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="space-y-2">
          <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Delay Hours</label>
          <input 
            type="number" 
            className="w-full px-6 py-4 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-700 rounded-2xl font-bold text-sm outline-none focus:ring-4 focus:ring-indigo-50"
            value={recoveryConfig.delayHours}
            onChange={(e) => handleChange('delayHours', parseInt(e.target.value))}
          />
        </div>
        <div className="space-y-2">
          <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Abandonment Threshold (Min)</label>
          <input 
            type="number" 
            className="w-full px-6 py-4 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-700 rounded-2xl font-bold text-sm outline-none focus:ring-4 focus:ring-indigo-50"
            value={recoveryConfig.abandonmentThresholdMin}
            onChange={(e) => handleChange('abandonmentThresholdMin', parseInt(e.target.value))}
          />
        </div>
      </div>
      
      <div className="space-y-2">
        <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Template ID</label>
        <input 
          type="text" 
          className="w-full px-6 py-4 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-700 rounded-2xl font-bold text-sm outline-none focus:ring-4 focus:ring-indigo-50"
          value={recoveryConfig.templateId}
          onChange={(e) => handleChange('templateId', e.target.value)}
        />
      </div>
    </div>
  );
};

export default RecoverySettings;
